import { DenouncedTraffic } from "../Model/DenouncedTraffic";
import { Query } from "../Model/Query";
import { Third } from "../Model/Third";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
export class DenouncedTrafficService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(thirdId, ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('denounced/traffic/' + ndiligencia + '/third_id/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener al agresor`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ndiligence`);
        }
    }
    async findByDiligenceNumber(ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('denounced/traffic/' + ndiligencia);
            if (!response.ok) {
                throw new Error(`Error al obtener al agresor`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ndiligence`);
        }
    }
    async saveDenouncedTraffic(denounded) {
        if (denounded) {
            const response = await this.apiService.post('denounced/traffic/', denounded);
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciado de tráfico.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener  tráfico.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`denounced/trafficThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async createDenouncedTraffic(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const third = new DenouncedTraffic({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                denouncedThirId: thirdId,
                optionalPart: " ",
                medicalHistory: " ",
                userId: getCurrentUser().id
            });
            const response = await this.apiService.post('denounced/traffic', third.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
    async deleteDenouncedTraffic(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('denounced/traffic/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciado de una diligencia trafico.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciado.`);
        }
    }
}
